export const paqImages = [
  {
    id: 'redpack',
    img: '/static/illustrations-flujo/paqueterias/redpack-2.png'
  },
  {
    id: 'estafeta',
    img: '/static/illustrations-flujo/paqueterias/estafeta-2.png'
  },
  {
    id: 'fedex',
    img: '/static/illustrations-flujo/paqueterias/fedex-2.webp'
  },
  {
    id: 'flecha amarilla',
    img: '/static/illustrations-flujo/paqueterias/flechaAmarilla-2.ico'
  },
  {
    id: 'ups',
    img: '/static/illustrations-flujo/paqueterias/ups.png'
  },
  {
    id: 'mienvio',
    img: '/static/illustrations-flujo/paqueterias/MiEnvio.png'
  },
  {
    id: 'superenvios',
    img: '/static/illustrations-flujo/paqueterias/superenvios.png'
  },
  {
    id: '99 minutos',
    img: '/static/illustrations-flujo/paqueterias/99-minutos.jpg'
  },
  {
    id: '99minutos',
    img: '/static/illustrations-flujo/paqueterias/99-minutos.jpg'
  },
  {
    id: 'dhl',
    img: '/static/illustrations-flujo/paqueterias/dhl.png'
  },
  {
    id: 'paqueteexpress',
    img: '/static/illustrations-flujo/paqueterias/paqueteexpress.png'
  },
  {
    id: 'altospack',
    img: '/static/illustrations-flujo/paqueterias/altosPack.jpeg'
  },
  {
    id: 'vencedor',
    img: '/static/illustrations-flujo/paqueterias/vencedor.png'
  },
  {
    id: 'j&t',
    img: '/static/illustrations-flujo/paqueterias/j&t.png'
  }
];

const proveedores = [
  {
    id: 'MIENVIO',
    name: 'MiEnvio',
    online: true,
    rate_providers: [
      {
        id: 'ESTAFETA',
        name: 'Estafeta',
        active: true,
        utility: 0
      },
      {
        id: '99_MINUTOS',
        name: '99 minutos',
        active: true,
        utility: 0
      },
      {
        id: 'FLECHA_AMARILLA',
        name: 'Flecha Amarilla',
        active: true,
        utility: 0
      },
      {
        id: 'FEDEX',
        name: 'Fedex',
        active: true,
        utility: 0
      },
      {
        id: 'DHL ',
        name: 'DHL ',
        active: true,
        utility: 0
      },
      {
        id: 'REDPACK',
        name: 'Redpack ',
        active: true,
        utility: 0
      }
    ]
  },
  {
    id: 'SUPERENVIOS',
    name: 'Superenvios',
    online: true,
    rate_providers: [
      {
        id: 'ESTAFETA',
        name: 'Estafeta',
        active: true,
        utility: 0
      },
      {
        id: 'UPS',
        name: 'UPS',
        active: true,
        utility: 0
      },
      {
        id: 'FEDEX',
        name: 'Fedex',
        active: true,
        utility: 0
      },
      {
        id: 'REDPACK',
        name: 'Redpack',
        active: true,
        utility: 0
      },
      {
        id: 'DHL ',
        name: 'DHL ',
        active: true,
        utility: 0
      }
    ]
  },
  {
    id: 'REDPACK',
    name: 'Redpack',
    online: true,
    rate_providers: [
      {
        id: 'REDPACK',
        name: 'Redpack ',
        active: true,
        utility: 0
      }
    ]
  },
  {
    id: 'UPS',
    name: 'UPS',
    online: true,
    rate_providers: [
      {
        id: 'UPS',
        name: 'UPS',
        active: true,
        utility: 0
      }
    ]
  }
];
